import React from 'react';
import { LargePrimaryButton, PrimaryButton, SmallPrimaryButton } from './style';
import { IButton } from './type';

const CorePrimaryButton = ({
	size = 'default',
	_width,
	style_type = 'filled',
	text,
	_margin,
	_disabled = false,
	_onClick,
	_ref,
	is_loading,
}: IButton) => {
	if (size === 'large')
		return (
			<LargePrimaryButton
				style_type={style_type}
				_width={_width}
				margin={_margin}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _onClick === undefined) return;
					_onClick(e);
				}}
				ref={_ref}
				is_loading={is_loading}
			>
				<span>{text}</span>
			</LargePrimaryButton>
		);

	if (size === 'small')
		return (
			<SmallPrimaryButton
				style_type={style_type}
				_width={_width}
				margin={_margin}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _onClick === undefined) return;
					_onClick(e);
				}}
				ref={_ref}
				is_loading={is_loading}
			>
				<span>{text}</span>
			</SmallPrimaryButton>
		);

	return (
		<PrimaryButton
			style_type={style_type}
			_width={_width}
			margin={_margin}
			disabled={_disabled}
			onClick={(e) => {
				if (is_loading || _onClick === undefined) return;
				_onClick(e);
			}}
			ref={_ref}
			tabIndex={0}
			is_loading={is_loading}
		>
			<span>{text}</span>
		</PrimaryButton>
	);
};

export default CorePrimaryButton;

// props
// - size: large, default, small
// - style_type: filled, tonal, outlined, text (피그마 참고)
// - text: button 텍스트
